export enum WorklistRowMode {
  Table = 'table',
  SemiItem = 'semi-item',
  Item = 'item',
}
